import { Box } from "@seneca/senekit";

import Timer from "features/common/components/Timer";

type Props = {
  endTime: string;
};

export default function SidebarTimer({ endTime }: Props) {
  return (
    <Box display="flex" justifyContent="center" padding="xlarge">
      <Timer endTime={endTime} />
    </Box>
  );
}
